import styled from "styled-components";
import { theme } from "uikit";

const Text = styled.div`
	font-family: "Lato";
	font-style: normal;
	font-weight: 700;
	font-size: 14px;
	line-height: 20px;

	color: ${theme.colors.primary};

	${theme.longWord}
`;

export default Text;
